// Components==============
import Spinner from 'components/UI/Spinner/Spinner';
import { useRedux } from 'hooks/useRedux';
import { TrainingDetailsContext } from 'pages/Workspace/TrainingDetails/TrainingDetails';
import React, { useContext } from 'react';
import './TopLeft.module.scss';
// =========================

export default function TopLeft({
  training,
  isOpen,
}: {
  training?: TrainingEntity;
  isOpen: boolean;
}) {
  const { loading } = useContext(TrainingDetailsContext);

  const clonedTraining = useRedux((state) =>
    training?.cloned_from_id
      ? state.training?.entities.byId[training?.cloned_from_id]
      : undefined
  );

  return (
    <div styleName="wrapper">
      <h1>
        {training?.title} <Spinner loading={loading} />
      </h1>
      {isOpen && (
        <p>
          {training?.cloned_from_id
            ? `${clonedTraining?.owner?.first_name} ${clonedTraining?.owner?.last_name} & ${training.owner?.first_name} ${training.owner?.last_name}`
            : `${training?.owner?.first_name} ${training?.owner?.last_name}`}
        </p>
      )}
    </div>
  );
}
